import PropTypes from 'prop-types';

export const colTitlesType = PropTypes.arrayOf(PropTypes.string.isRequired);

export const tableRowsType = PropTypes.arrayOf(
  PropTypes.shape({
    rowTitle: PropTypes.string,
    rowSubtitle: PropTypes.string,
    // cell shape can be changed to allow for custom content
    cells: PropTypes.arrayOf(PropTypes.any),
  }),
);

const tableDataType = PropTypes.exact({
  colTitles: colTitlesType,
  rows: tableRowsType,
});

export default tableDataType;
